import { LOGIN, REFRESH_TOKEN } from 'store/mutation-types';

const login = ({ commit }, token) => {
  commit(LOGIN, token);
};

const refreshToken = ({ commit }, token) => {
  commit(REFRESH_TOKEN, token);
};

export default {
  login,
  refreshToken,
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/authentication.actions.js